import React from "react";
import Modal from "../../../components/common/Modal";
import BranchAccessManager from "./BranchAccessManager";

const BranchAccessModal = ({ admin, isOpen, onClose }) => {
  if (!admin) return null;

  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      title="Manage Branch Access"
      maxWidth="4xl"
      className="sm:max-w-4xl"
    >
      <BranchAccessManager admin={admin} onClose={onClose} />
    </Modal>
  );
};

export default BranchAccessModal;
